<div class="alert alert-warning" role="alert" *ngIf="refundBlockedPaymentType">
  {{ refundBlockedMessage }}
</div>

<div class="form-group">
  <div class="form-check">
    <input class="form-check-input" type="radio"
           name="refundLastPayment" id="noRefund"
           [(ngModel)]="refundPolicy" [value]="REFUND_POLICY.noRefund">
    <label class="form-check-label" for="noRefund">No refund</label>
  </div>
  <div class="form-check" *ngIf="membership.last_invoice_amount">
    <input class="form-check-input" type="radio"
           name="refundLastPayment" id="refundLastPayment"
           [disabled]="!!refundBlockedPaymentType"
           [(ngModel)]="refundPolicy" [value]="REFUND_POLICY.refundLastPayment">
    <label class="form-check-label" for="refundLastPayment"
           [class.text-muted]="refundBlockedPaymentType">
      Refund last billed amount ({{ orgConfigService.getCurrencySymbol() }}{{ membership.last_invoice_amount }})
    </label>
  </div>
  <div class="form-check" *ngIf="refundCreditAmount > 0">
    <input class="form-check-input" type="radio"
           name="refundLastPayment" id="refundCredit"
           [(ngModel)]="refundPolicy" [value]="REFUND_POLICY.refundCredit">
    <label class="form-check-label" for="refundCredit">
      Refund prorated credit for remainder of billing period ({{ orgConfigService.formatCurrency(refundCreditAmount) }})
    </label>
  </div>
</div>

<div class="form-group" *ngIf="orgConfigService.getOrganizationConfig().require_membership_cancellation_reason">
  <label for="reasonSelect">Cancellation Reason</label>
  <select class="custom-select"
          name="reason" id="reasonSelect"
          [(ngModel)]="reason">
    <option [ngValue]="null" disabled>---</option>
    <option *ngFor="let reasonOption of orgConfigService.getOrganizationConfig().membership_cancellation_reason_options"
            [ngValue]="reasonOption">{{ reasonOption }}</option>
  </select>
</div>

<div class="form-group">
  <label>Customize Customer Email Confirmation</label>
  <app-markdown-editor [(content)]="cancellationEmailText" [id]="'cancellationEmailText'"></app-markdown-editor>
</div>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
